import * as PIXI from "pixi.js";
import Game from "../Game";
import { getPolygonConDeltail } from "../types/config";
import BaseController from "./baseController";

export default class RadiusCon extends BaseController {
  Game: Game = Game.getInstance();

  constructor() {
    super("Shrink/grow polygon", "radiusChange", 160, 50, 0, 0x0000FF);
    const { x, y, width } = getPolygonConDeltail(this.Game.getDim());
    this.Game.topContainer.addChild(this);
    this.x = x + width + 20;
    this.y = y + 200;
  }

}